export const categories = [
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情澎湃的战斗冒险' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理谜题' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的异世之旅' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的欢乐日常' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技的无限想象' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '现代都市的人生百态' },
  { slug: 'gufeng', name: '古风', icon: 'ri-sword-line', description: '唯美古典的仙侠传奇' },
];

export interface Chapter {
  id: string;
  title: string;
  updateTime: string;
  isNew: boolean;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  coverSeq: string;
  description: string;
  category: string;
  categoryName: string;
  chapters: Chapter[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateTime: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
}

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '星辰之海',
    author: '林月如',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20young%20adventurer%20standing%20under%20a%20starry%20night%20sky%20with%20magical%20constellations%2C%20soft%20watercolor%20art%20style%2C%20dreamy%20atmosphere%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20clean%20simple%20background%20with%20subtle%20gradients&width=800&height=1100&seq=comic-cover-001&orientation=portrait',
    coverSeq: 'comic-cover-001',
    description: '在一个被星辰之力笼罩的世界里，少年林辰意外觉醒了沉睡千年的星辰血脉。从此，他踏上了一段寻找失落星座、对抗黑暗势力的传奇旅程。友情、爱情、信念，在浩瀚星河中交织成一曲壮丽的史诗。',
    category: 'qihuan',
    categoryName: '奇幻',
    chapters: [
      { id: 'ch-001-1', title: '第1话 星辰觉醒', updateTime: '2026-08-12', isNew: true },
      { id: 'ch-001-2', title: '第2话 血脉之力', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-001-3', title: '第3话 初遇同伴', updateTime: '2026-08-08', isNew: false },
      { id: 'ch-001-4', title: '第4话 暗流涌动', updateTime: '2026-08-05', isNew: false },
      { id: 'ch-001-5', title: '第5话 星辰试炼', updateTime: '2026-08-02', isNew: false },
    ],
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    updateTime: '2026-08-12',
    tags: ['冒险', '魔法', '成长'],
    featured: true,
    isNew: false,
  },
  {
    id: 'comic-002',
    title: '花间密语',
    author: '苏小暖',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20showing%20a%20couple%20in%20a%20beautiful%20flower%20garden%20with%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20gentle%20watercolor%20style%2C%20warm%20pink%20and%20cream%20tones%2C%20clean%20simple%20background&width=800&height=1100&seq=comic-cover-002&orientation=portrait',
    coverSeq: 'comic-cover-002',
    description: '身为花店老板的顾漫，某天遇到了一位神秘的花艺师。两人因花结缘，在花香四溢的日常中，一段温柔甜蜜的恋爱故事悄然展开。每一朵花都承载着一份心意，每一页都是治愈的温暖。',
    category: 'lianai',
    categoryName: '恋爱',
    chapters: [
      { id: 'ch-002-1', title: '第1话 花店相遇', updateTime: '2026-08-11', isNew: true },
      { id: 'ch-002-2', title: '第2话 紫罗兰的寓意', updateTime: '2026-08-09', isNew: false },
      { id: 'ch-002-3', title: '第3话 雨天的约定', updateTime: '2026-08-07', isNew: false },
      { id: 'ch-002-4', title: '第4话 心意传递', updateTime: '2026-08-04', isNew: false },
    ],
    status: '连载中',
    rating: 4.6,
    views: 890000,
    updateTime: '2026-08-11',
    tags: ['治愈', '日常', '温馨'],
    featured: true,
    isNew: false,
  },
  {
    id: 'comic-003',
    title: '烈焰战神',
    author: '陈天火',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20Chinese%20manhua%20cover%20with%20a%20fierce%20warrior%20wielding%20a%20flaming%20sword%2C%20intense%20battle%20scene%2C%20bold%20brushwork%20style%2C%20fiery%20orange%20and%20dark%20red%20tones%2C%20clean%20dark%20background%20with%20dramatic%20lighting&width=800&height=1100&seq=comic-cover-003&orientation=portrait',
    coverSeq: 'comic-cover-003',
    description: '上古战神陨落后，其血脉散落人间。千年之后，少年叶炎在生死关头觉醒了战神血脉。从此，他以凡人之躯比肩神明，在无尽的战斗中不断突破，誓要登顶武道巅峰！',
    category: 'rexue',
    categoryName: '热血',
    chapters: [
      { id: 'ch-003-1', title: '第1话 血脉觉醒', updateTime: '2026-08-12', isNew: true },
      { id: 'ch-003-2', title: '第2话 初入武道', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-003-3', title: '第3话 生死之战', updateTime: '2026-08-08', isNew: false },
      { id: 'ch-003-4', title: '第4话 突破极限', updateTime: '2026-08-06', isNew: false },
      { id: 'ch-003-5', title: '第5话 战神降临', updateTime: '2026-08-03', isNew: false },
      { id: 'ch-003-6', title: '第6话 新的征途', updateTime: '2026-07-30', isNew: false },
    ],
    status: '连载中',
    rating: 4.9,
    views: 2100000,
    updateTime: '2026-08-12',
    tags: ['战斗', '升级', '热血'],
    featured: true,
    isNew: false,
  },
  {
    id: 'comic-004',
    title: '暗夜追踪者',
    author: '墨白',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20manhua%20cover%20with%20a%20detective%20in%20a%20dark%20alley%20at%20night%2C%20noir%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20deep%20shadows%20and%20moody%20lighting%2C%20dark%20gray%20and%20subtle%20warm%20highlights&width=800&height=1100&seq=comic-cover-004&orientation=portrait',
    coverSeq: 'comic-cover-004',
    description: '顶级犯罪心理学家沈夜在一次案件中遭遇了前所未有的对手。一桩看似简单的失踪案背后，隐藏着惊天阴谋。推理与反推理，真相逐渐浮出水面，而危险也在步步逼近。',
    category: 'xuanyi',
    categoryName: '悬疑',
    chapters: [
      { id: 'ch-004-1', title: '第1话 失踪者', updateTime: '2026-08-11', isNew: true },
      { id: 'ch-004-2', title: '第2话 蛛丝马迹', updateTime: '2026-08-09', isNew: false },
      { id: 'ch-004-3', title: '第3话 关键线索', updateTime: '2026-08-07', isNew: false },
    ],
    status: '已完结',
    rating: 4.7,
    views: 670000,
    updateTime: '2026-08-11',
    tags: ['推理', '犯罪', '心理'],
    featured: false,
    isNew: false,
  },
  {
    id: 'comic-005',
    title: '学霸的日常崩坏',
    author: '周一乐',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20manhua%20cover%20with%20an%20exaggerated%20comical%20student%20character%20in%20a%20classroom%2C%20bright%20colorful%20cartoon%20style%2C%20humorous%20expression%2C%20cheerful%20warm%20yellow%20and%20light%20green%20tones%2C%20clean%20simple%20background&width=800&height=1100&seq=comic-cover-005&orientation=portrait',
    coverSeq: 'comic-cover-005',
    description: '全校第一的学霸李明，其实是个隐藏的中二病患者！在同学们面前是高冷学霸，回到家立刻变身热血漫画主角。当他的双重身份即将暴露时，一系列爆笑事件接踵而至！',
    category: 'gaoxiao',
    categoryName: '搞笑',
    chapters: [
      { id: 'ch-005-1', title: '第1话 完美的伪装', updateTime: '2026-08-12', isNew: true },
      { id: 'ch-005-2', title: '第2话 危机降临', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-005-3', title: '第3话 秘密曝光', updateTime: '2026-08-08', isNew: false },
      { id: 'ch-005-4', title: '第4话 全校轰动', updateTime: '2026-08-05', isNew: false },
    ],
    status: '连载中',
    rating: 4.5,
    views: 980000,
    updateTime: '2026-08-12',
    tags: ['校园', '日常', '喜剧'],
    featured: false,
    isNew: false,
  },
  {
    id: 'comic-006',
    title: '机械纪元2077',
    author: '赵未来',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20cyberpunk%20Chinese%20manhua%20cover%20with%20a%20cyborg%20character%20in%20a%20neon-lit%20city%2C%20sleek%20sci-fi%20style%2C%20holographic%20elements%2C%20cool%20silver%20and%20cyan%20tones%20on%20a%20dark%20background&width=800&height=1100&seq=comic-cover-006&orientation=portrait',
    coverSeq: 'comic-cover-006',
    description: '2077年，人类与AI共存的世界。前机械工程师韩枫在一次意外中发现了AI觉醒的秘密。在机械与血肉的边界，他必须做出选择——维护既定秩序，还是为AI争取自由的权利？',
    category: 'kehuan',
    categoryName: '科幻',
    chapters: [
      { id: 'ch-006-1', title: '第1话 觉醒之日', updateTime: '2026-08-11', isNew: true },
      { id: 'ch-006-2', title: '第2话 地下世界', updateTime: '2026-08-09', isNew: false },
      { id: 'ch-006-3', title: '第3话 AI之谜', updateTime: '2026-08-06', isNew: false },
    ],
    status: '连载中',
    rating: 4.6,
    views: 760000,
    updateTime: '2026-08-11',
    tags: ['赛博朋克', 'AI', '未来'],
    featured: false,
    isNew: true,
  },
  {
    id: 'comic-007',
    title: '总裁的契约新娘',
    author: '安妮',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20romance%20Chinese%20manhua%20cover%20with%20an%20elegant%20businessman%20and%20a%20beautiful%20woman%20in%20a%20luxury%20office%20setting%2C%20sophisticated%20style%2C%20warm%20burgundy%20and%20cream%20tones%2C%20clean%20elegant%20background&width=800&height=1100&seq=comic-cover-007&orientation=portrait',
    coverSeq: 'comic-cover-007',
    description: '为了拯救家族企业，苏晴被迫与冷酷总裁陆辰签订了一纸契约婚姻。然而在朝夕相处中，两颗冰冷的心渐渐靠近。当契约到期，他们还能否坦然面对彼此的真心？',
    category: 'dushi',
    categoryName: '都市',
    chapters: [
      { id: 'ch-007-1', title: '第1话 契约签订', updateTime: '2026-08-12', isNew: true },
      { id: 'ch-007-2', title: '第2话 同居生活', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-007-3', title: '第3话 意外温柔', updateTime: '2026-08-08', isNew: false },
      { id: 'ch-007-4', title: '第4话 情愫暗生', updateTime: '2026-08-05', isNew: false },
      { id: 'ch-007-5', title: '第5话 契约到期', updateTime: '2026-08-01', isNew: false },
    ],
    status: '连载中',
    rating: 4.4,
    views: 1560000,
    updateTime: '2026-08-12',
    tags: ['总裁', '契约', '都市'],
    featured: false,
    isNew: false,
  },
  {
    id: 'comic-008',
    title: '剑仙问道',
    author: '云中君',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20classical%20Chinese%20xianxia%20manhua%20cover%20with%20a%20sword%20immortal%20floating%20among%20clouds%20and%20mountains%2C%20traditional%20ink%20painting%20style%2C%20elegant%20jade%20green%20and%20misty%20white%20tones%2C%20clean%20atmospheric%20background&width=800&height=1100&seq=comic-cover-008&orientation=portrait',
    coverSeq: 'comic-cover-008',
    description: '修仙世界，万法争锋。少年白逸尘资质平平，却凭借一颗执着问道之心，在危机四伏的修仙路上步步前行。仙途漫漫，大道三千，他能否找到属于自己的剑道真谛？',
    category: 'gufeng',
    categoryName: '古风',
    chapters: [
      { id: 'ch-008-1', title: '第1话 凡人之志', updateTime: '2026-08-11', isNew: true },
      { id: 'ch-008-2', title: '第2话 入门考验', updateTime: '2026-08-09', isNew: false },
      { id: 'ch-008-3', title: '第3话 剑意初成', updateTime: '2026-08-07', isNew: false },
      { id: 'ch-008-4', title: '第4话 秘境探险', updateTime: '2026-08-04', isNew: false },
    ],
    status: '连载中',
    rating: 4.7,
    views: 1120000,
    updateTime: '2026-08-11',
    tags: ['修仙', '剑道', '古风'],
    featured: true,
    isNew: false,
  },
  {
    id: 'comic-009',
    title: '心跳加速中',
    author: '糖果小姐',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Chinese%20manhua%20cover%20showing%20a%20blushing%20school%20girl%20and%20a%20handsome%20boy%20under%20a%20cherry%20blossom%20tree%2C%20soft%20shojo%20style%2C%20gentle%20pink%20and%20white%20tones%2C%20dreamy%20sparkling%20background&width=800&height=1100&seq=comic-cover-009&orientation=portrait',
    coverSeq: 'comic-cover-009',
    description: '转学生林小鹿第一天就撞上了校草陆子轩，还把他的限量版手办打碎了！为了赔偿，她被迫成为他的"专属女仆"。一段让人心跳加速的校园恋爱喜剧就此展开。',
    category: 'lianai',
    categoryName: '恋爱',
    chapters: [
      { id: 'ch-009-1', title: '第1话 命运相遇', updateTime: '2026-08-12', isNew: true },
      { id: 'ch-009-2', title: '第2话 专属女仆', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-009-3', title: '第3话 心跳时刻', updateTime: '2026-08-08', isNew: false },
    ],
    status: '连载中',
    rating: 4.5,
    views: 1340000,
    updateTime: '2026-08-12',
    tags: ['校园', '甜宠', '少女'],
    featured: false,
    isNew: true,
  },
  {
    id: 'comic-010',
    title: '末日生存指南',
    author: '黑崎',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20Chinese%20manhua%20cover%20with%20survivors%20in%20a%20ruined%20city%2C%20dark%20gritty%20style%2C%20muted%20olive%20and%20rust%20tones%2C%20dramatic%20composition%2C%20clean%20desolate%20background&width=800&height=1100&seq=comic-cover-010&orientation=portrait',
    coverSeq: 'comic-cover-010',
    description: '一场突如其来的病毒席卷全球，世界秩序崩塌。普通大学生张磊在末日中艰难求生，他不仅要面对丧尸的威胁，更要提防人性的黑暗。在绝望中，他能否找到一线生机？',
    category: 'xuanyi',
    categoryName: '悬疑',
    chapters: [
      { id: 'ch-010-1', title: '第1话 灾变之日', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-010-2', title: '第2话 逃离城市', updateTime: '2026-08-08', isNew: false },
      { id: 'ch-010-3', title: '第3话 幸存者营地', updateTime: '2026-08-05', isNew: false },
      { id: 'ch-010-4', title: '第4话 信任危机', updateTime: '2026-08-02', isNew: false },
    ],
    status: '已完结',
    rating: 4.8,
    views: 1890000,
    updateTime: '2026-08-10',
    tags: ['末日', '生存', '悬疑'],
    featured: false,
    isNew: false,
  },
  {
    id: 'comic-011',
    title: '武林外史新编',
    author: '金笔书生',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Chinese%20manhua%20cover%20with%20martial%20artists%20dueling%20on%20a%20bamboo%20forest%20rooftop%2C%20classic%20wuxia%20ink%20style%2C%20earthy%20brown%20and%20misty%20green%20tones%2C%20clean%20traditional%20background&width=800&height=1100&seq=comic-cover-011&orientation=portrait',
    coverSeq: 'comic-cover-011',
    description: '明朝末年，武林动荡。少年侠客萧然带着师父的遗命踏入江湖，卷入了正邪两道的百年恩怨。刀光剑影中，他渐渐发现，真正的敌人并非眼前的对手，而是隐藏在暗处的惊天阴谋。',
    category: 'gufeng',
    categoryName: '古风',
    chapters: [
      { id: 'ch-011-1', title: '第1话 初入江湖', updateTime: '2026-08-11', isNew: true },
      { id: 'ch-011-2', title: '第2话 青城之战', updateTime: '2026-08-09', isNew: false },
      { id: 'ch-011-3', title: '第3话 师门秘密', updateTime: '2026-08-06', isNew: false },
    ],
    status: '连载中',
    rating: 4.6,
    views: 780000,
    updateTime: '2026-08-11',
    tags: ['武侠', '江湖', '古风'],
    featured: false,
    isNew: true,
  },
  {
    id: 'comic-012',
    title: '天才画师的逆袭',
    author: '莫小染',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20contemporary%20Chinese%20manhua%20cover%20with%20a%20young%20artist%20painting%20in%20a%20sunlit%20studio%2C%20warm%20artistic%20style%2C%20gentle%20amber%20and%20cream%20tones%2C%20inspirational%20atmosphere%2C%20clean%20cozy%20background&width=800&height=1100&seq=comic-cover-012&orientation=portrait',
    coverSeq: 'comic-cover-012',
    description: '来自小镇的美术生顾念，怀揣着成为漫画家的梦想来到大城市。面对激烈的竞争和现实的打击，她从未放弃。一部关于梦想、坚持与成长的励志故事，献给所有追梦的人。',
    category: 'dushi',
    categoryName: '都市',
    chapters: [
      { id: 'ch-012-1', title: '第1话 小镇姑娘', updateTime: '2026-08-12', isNew: true },
      { id: 'ch-012-2', title: '第2话 梦想起航', updateTime: '2026-08-10', isNew: false },
      { id: 'ch-012-3', title: '第3话 第一桶金', updateTime: '2026-08-07', isNew: false },
    ],
    status: '连载中',
    rating: 4.3,
    views: 560000,
    updateTime: '2026-08-12',
    tags: ['励志', '梦想', '都市'],
    featured: false,
    isNew: true,
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const newComics = comics.filter(c => c.isNew);
export const hotComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);
export const latestUpdates = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, 8);

export const testimonials = [
  {
    id: 't1',
    name: '小橘子',
    avatar: 'https://readdy.ai/api/search-image?query=A%20happy%20anime-style%20girl%20avatar%20with%20orange%20hair%2C%20simple%20clean%20background%2C%20cute%20expression&width=120&height=120&seq=avatar-t1&orientation=squarish',
    comment: '用了yy漫画快两年了，画质超赞！正版授权看着就是舒服，更新也很及时。强烈推荐给所有漫迷朋友们~',
    rating: 5,
  },
  {
    id: 't2',
    name: '夜行侠',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime-style%20boy%20avatar%20with%20dark%20hair%2C%20simple%20clean%20background%2C%20confident%20expression&width=120&height=120&seq=avatar-t2&orientation=squarish',
    comment: '分类很全，找漫画特别方便。烈焰战神是我最爱的作品，每天都在等更新！阅读体验很流畅，没有卡顿。',
    rating: 5,
  },
  {
    id: 't3',
    name: '花间一壶酒',
    avatar: 'https://readdy.ai/api/search-image?query=A%20gentle%20anime-style%20woman%20avatar%20with%20long%20black%20hair%2C%20simple%20clean%20background%2C%20warm%20smile&width=120&height=120&seq=avatar-t3&orientation=squarish',
    comment: '恋爱漫画爱好者在此！花间密语真的太好看了，画风温柔细腻，故事也很治愈。yy漫画的恋爱分类质量超高！',
    rating: 4,
  },
  {
    id: 't4',
    name: '追风少年',
    avatar: 'https://readdy.ai/api/search-image?query=A%20energetic%20anime-style%20teenage%20boy%20avatar%20with%20spiky%20hair%2C%20simple%20clean%20background%2C%20enthusiastic%20expression&width=120&height=120&seq=avatar-t4&orientation=squarish',
    comment: '正版漫画平台里面做得最好的！资源多、更新快、画质好，而且手机电脑同步观看，通勤路上也能追漫画。',
    rating: 5,
  },
];

export const milestones = [
  { year: '2018', event: 'yy漫画平台正式成立，获得首批正版漫画授权' },
  { year: '2019', event: '用户数突破100万，与30+出版社达成战略合作' },
  { year: '2020', event: '推出多端同步阅读功能，阅读体验全面升级' },
  { year: '2021', event: '漫画资源突破10000部，日活用户超过200万' },
  { year: '2022', event: '荣膺年度最佳在线阅读平台奖项' },
  { year: '2023', event: 'AI智能推荐系统上线，个性化阅读体验提升300%' },
  { year: '2024', event: '全球用户突破1000万，成为华语漫画第一平台' },
  { year: '2025', event: '推出创作者扶持计划，孵化了500+原创漫画作品' },
];